<!-- <template>
    <mkeep-alive :include="keepAlive">
        <slot></slot>
    </mkeep-alive>
</template> -->
<script>
    import keepStatus from './keep-alive.js'
    export default keepStatus
</script>


// WEBPACK FOOTER //
// keep-status.vue?13298571